import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateFreezeApplication, UpdateFreezeApplicationData } from "@/http/freezeApplicationsApi";
import { getFreezeApplicationsQueryKey } from "@/utils/queryKeys";

interface UpdateFreezeApplicationParams {
  phone: string;
  applicationId: number;
  data: UpdateFreezeApplicationData;
}

export const useUpdateFreezeApplicationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ phone, applicationId, data }: UpdateFreezeApplicationParams) => {
      const response = await updateFreezeApplication(phone, applicationId, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getFreezeApplicationsQueryKey(),
      });
    },
  });
};
